import { colors } from "@styles/colors";
import { Text } from "tamagui";

export const ALERT_STATE = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
} as const;

type AlertStateValues = (typeof ALERT_STATE)[keyof typeof ALERT_STATE];

const stateConfig = {
  [ALERT_STATE.SUCCESS]: {
    color: "$green10",
    backgroundColor: "#e6fffa",
  },
  [ALERT_STATE.ERROR]: {
    color: "$red10",
    backgroundColor: colors.bgRed,
  },
  [ALERT_STATE.WARNING]: {
    color: "$yellow10",
    backgroundColor: "#fffbeb",
  },
} as const;

interface AlertProps {
  text: string;
  state: AlertStateValues;
}

const Alert = ({ text, state }: AlertProps) => {
  const config = stateConfig[state] || stateConfig.error;
  return (
    <Text
      width="100%"
      color={config.color}
      backgroundColor={config.backgroundColor}
      fontSize={12}
      padding="$2"
      borderRadius="$2"
      fontWeight="800"
      marginTop="$2.5"
      style={{ display: "block" }}>
      {text}
    </Text>
  );
};

export default Alert;
